export const events = [
    {
        id: "1",
        title: "Mondrian Evolution",
        slogan: "Ein Date mit Mondrian",
        eventType: "Ausstellung",
        startDate: "2022-06-05T18:00:00",
        endDate: "2022-10-09T20:00:00",
        shortDescription: "Anlässlich des 150. Geburtstags des Künstlers widmet die Fondation Beyeler dem niederländischen Maler Piet Mondrian eine umfassende Ausstellung.",
        description: "<p>Als einer der bedeutendsten Künstler der Avantgarde-Bewegung hat er die Entwicklung der Malerei von der Figuration zur Abstraktion massgebend geprägt. Mondrians frühes Werk wird von der niederländischen Landschaftsmalerei des späten 19. Jahrhunderts bestimmt, aber auch Symbolismus und Kubismus waren von grosser Bedeutung für ihn.</p><p>Während die Sammlung der Fondation Beyeler vor allem Bilder aus den späteren Schaffensphasen Mondrians beinhaltet, liegt der Fokus dieser Ausstellung auf Werken, welche Mondrians künstlerische Entwicklung bis in die zwanziger Jahre und die stilistische Entstehung seines Spätwerks beleuchtet.</p>",
        titleImage: "./images/events/MondrianTitleImage.png",
        isHighlight: true,
        saalheftId: "1",
    },
    {
        id: "2",
        title: "Anne Imhof",
        slogan: "ARTIST TALK",
        eventType: "Artist Talk",
        startDate: "2023-09-25T11:00:00",
        endDate: "2023-09-25T12:00:00",
        sections: [
            {
                title: "Über Anne Imhof",
                html: "<p>Die zeitgenössische britische Malerin und Schriftstellerin Lynette Yiadom-Boakye wurde 1977 in London geboren, wo sie auch heute lebt und arbeitet. Sie ist bekannt für ihren figurativen Stil und stellt oft Menschen in zeitlosen, fast gesichtslosen Umgebungen.</p><p>Im Gespräch mit Hans-Ulrich Obrist, Artistic Director der Serpentine, spricht sie über ihr Leben und ihre Arbeit.</p>",
            },
            {
                title: "ARTIST TALK",
                html: "<p>Artist Talks ist ein Programm der Fondation Beyeler und von UBS, innerhalb dessen international renommierte, zeitgenössische Künstler über ihre Arbeit sprechen. Das Format ist offen und dynamisch angelegt und reicht vom klassischen Künstlervortrag bis hin zu moderierten Gesprächen zwischen Künstlern und Persönlichkeiten der Kunstwelt. Die Artist Talks finden in der Fondation Beyeler in Riehen/Basel und weiteren Kunstinstitutionen in Europa, Asien, Lateinamerika und USA statt.</p>",
            },
        ],
        titleImage: "./images/events/anne_imhof.png",
        slideShowImages: [],
        isHighlight: true,
    },
    {
        id: "3",
        title: "GEFÜHRTER SPAZIERGANG",
        eventType: "Event",
        startDate: "2023-09-25T11:00:00",
        endDate: "2023-09-25T12:00:00",
        titleImage: "./images/events/spaziergang.png",
        isHighlight: true,
    },
    {
        id: "4",
        title: "Friday Beyeler",
        eventType: "Event",
        startDate: "2023-09-25T11:00:00",
        endDate: "2023-09-25T12:00:00",
        titleImage: "./images/events/friday.png",
        isHighlight: true,
    },
]

import axios from "../../api-client";

export const getEvents = async () => {
    const response = await axios.get("/api/event");
    //const fondationEvents = await axios.get("/api/fondationEvents/").then((response) => response.data).catch((error) => []);
    return response.data;
}

export const getFondationEvents = async () => {
    const response = await axios.get("/api/fondationEvents").catch((error) => []);
    return response.data.filter((event) => event != undefined);
}


export const getEvent = async (id) => {
    if (!isNaN(id)) {
        return getEventFromFondationAPI(id);
    }
    const response = await axios.get(`/api/event/${id}`);
    return response.data;
}

export const createEvent = async (event) => {
    const response = await axios.post("/api/event", event);
    return response.data;
}

/* Functions for fetching & parsing Events from the Fondation API */

export const getEventFromFondationAPI = async (id) => {
    const response = await axios.get(`/api/fondationEvents/${id}`).catch((error) => undefined);
    return response.data;
}

const parseFondationEventsToEvents = (fondationEvents, language) => {
    return Object.keys(fondationEvents)
        .map((key) => fondationEvents[key])
        .map((fondationEvent) => parseFondationEventToEvent(fondationEvent, language));
}

const parseFondationEventToEvent = (fondationEvent, language) => {
    const { startDate, endDate } = getStartAndEndDate(fondationEvent);
    return {
        id: fondationEvent.sourceBpId,
        title: fondationEvent.offerDetail.de.title,
        eventType: getEventType(fondationEvent),
        startDate,
        endDate,
        description: getDescription(fondationEvent),
        titleImage: fondationEvent.images,
        isHighlight: false,
    }
}

const getEventType = (fondationEvent) => {
    const categories = fondationEvent.categories;
    const firstKey = Object.keys(categories)[0];
    return categories[firstKey].title;
}

const getStartAndEndDate = (fondationEvent) => {
    const scheduleKeys = Object.keys(fondationEvent.schedules);
    const nextSchedule = findNextSchedule(fondationEvent, scheduleKeys);
    const startDate = new Date(nextSchedule.startDate + "T" + nextSchedule.startTime);
    const endDate = new Date(nextSchedule.startTime + "T" + nextSchedule.endTime);
    return { startDate, endDate };
}

const getDescription = (fondationEvent) => {
    const description = fondationEvent.offerDetail.de.longDescription;
    const shortDescription = fondationEvent.offerDetail.de.shortDescription;
    return "<b>" + shortDescription + "</b><br>" + description;
}

const findNextSchedule = (fondationEvent, scheduleKeys) => {
    const nextSchedule = scheduleKeys.find((key) => {
        const schedule = fondationEvent.schedules[key];
        const startDate = new Date(schedule.startDate);
        const now = new Date();
        return startDate > now;
    });
    return fondationEvent.schedules[nextSchedule];
}
